<template>
 <div class="">
    <masternav/>
    <br>
    <modifyreservecomp/>
    <br>
    <mainfooter/>
 </div> 
</template>

<script>
// @ is an alias to /src
import masternav                from '@/components/masternav.vue'
import mainfooter               from '@/components/mainfooter.vue'
import modifyreservecomp        from '@/components/modifyreservecomp' 
export default {
  name: 'Fleet',
  components: {
    masternav,
    mainfooter,
    modifyreservecomp
  }
}
</script>